import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useLocation, useHistory } from "react-router-dom";
import "../../assets/css/new-website.css";

const validationSchema = Yup.object({
  username: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid email format").required("Email is required"),
  phone: Yup.string().matches(/^[0-9]{10}$/, "Phone number must be 10 digits").required("Phone number is required"),
  painpoints: Yup.string().required("Pain point is required"),
  date: Yup.string().required("Date is required"),
  timeslot: Yup.string().required("Time Slot is required"),
  agree: Yup.boolean().oneOf([true], "You must accept the terms and conditions")
});

const ReachToUsFormLanding = () => {
  const [showTimeSlots, setShowTimeSlots] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const slug = location.pathname.replace(/^\/|\/$/g, '') || 'home';

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const contactData = {
        Name: values.username,
        Email: values.email,
        Phone: values.phone,
        PainPoints: values.painpoints,
        PreferredDate: values.date,
        TimeSlot: values.timeslot,
        Message: values.message,
        Page_Slug: slug,
        Lead_Source: "Website",
        Form_Section: "",
      };

      // Send base data to Strapi
      const res = await axios.post("https://admin.bridgehealth.in/api/contact-forms", {
        data: contactData,
      });

      // UTM and IP logic for Google Sheet
      const urlParams = new URLSearchParams(window.location.search);
      const utmData = {
        UTM_Source: urlParams.get("utm_source") || "",
        UTM_Medium: urlParams.get("utm_medium") || "",
        UTM_Campaign: urlParams.get("utm_campaign") || "",
        UTM_Term: urlParams.get("utm_term") || "",
        UTM_Content: urlParams.get("utm_content") || "",
        UTM_Refer: document.referrer || "",
      };

      const ipRes = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipRes.json();
      const IP_Address = ipData.ip || "";

      const googleSheetData = {
        ...contactData,
        ...utmData,
        IP_Address,
      };

      const urlData = new URLSearchParams();
      Object.entries(googleSheetData).forEach(([key, val]) => urlData.append(key, val));

      await fetch("https://script.google.com/macros/s/AKfycbzW40R7nnVdSr5ibvwhX4Zag7mMry5BT3KvcXagaRO9jejco5oywvkqXsQ3cnfvA9RL/exec", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: urlData.toString(),
      });

      if (res.status === 200) {
        resetForm();
        history.push("/thankyou");
      }
    } catch (error) {
      console.log("Error submitting form:", error);
    }
  };

  return (
    <div className="px-1 py-1">
      <Formik
        initialValues={{
          username: "",
          email: "",
          phone: "",
          painpoints: "",
          date: "",
          timeslot: "",
          message: "",
          agree: true
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, setFieldValue }) => (
          <Form className="def-new-form row">
            <div className="col-lg-12">
              <Field name="username" type="text" className="form-control" placeholder="Name*" />
              <ErrorMessage name="username" component="div" className="error" />
            </div>

            <div className="col-lg-12">
              <Field name="email" type="email" className="form-control" placeholder="Email*" />
              <ErrorMessage name="email" component="div" className="error" />
            </div>

            <div className="col-lg-12">
              <Field name="phone" type="tel" className="form-control" placeholder="Phone*" />
              <ErrorMessage name="phone" component="div" className="error" />
            </div>

            <div className="col-lg-12">
              <Field name="painpoints" as="select" className="form-control">
                <option value="">Select Pain Point*</option>
                <option value="Back Pain">Back Pain</option>
                <option value="Neck Pain">Neck Pain</option>
                <option value="Shoulder Pain">Shoulder Pain</option>
                <option value="Knee Pain">Knee Pain</option>
                <option value="Sports Injury">Sports Injury</option>
                <option value="Other">Other</option>
              </Field>
              <ErrorMessage name="painpoints" component="div" className="error" />
            </div>

            <div className="col-lg-12">
              <label htmlFor="date" className="slot-label">Preferred date to receive call</label>
              <Field name="date">
                {({ field }) => (
                  <input
                    {...field}
                    type="date"
                    className="form-control"
                    onChange={(e) => {
                      const selectedDate = e.target.value;
                      setFieldValue("date", selectedDate);
                      setShowTimeSlots(!!selectedDate);
                    }}
                  />
                )}
              </Field>
              <ErrorMessage name="date" component="div" className="error" />
            </div>

            {showTimeSlots && (
              <div className="col-lg-12 mt-3">
                <Field name="timeslot" as="select" className="form-control">
                  <option value="">Select a time slot</option>
                  <option value="Slot 09:00-10:00">09:00 - 10:00</option>
                  <option value="Slot 10:00-11:00">10:00 - 11:00</option>
                  <option value="Slot 11:00-12:00">11:00 - 12:00</option>
                  <option value="Slot 12:00-13:00">12:00 - 13:00</option>
                  <option value="Slot 13:00-14:00">13:00 - 14:00</option>
                  <option value="Slot 14:00-15:00">14:00 - 15:00</option>
                  <option value="Slot 15:00-16:00">15:00 - 16:00</option>
                  <option value="Slot 16:00-17:00">16:00 - 17:00</option>
                </Field>
                <ErrorMessage name="timeslot" component="div" className="error" />
              </div>
            )}

            <div className="col-lg-12">
              <Field
                name="message"
                as="textarea"
                className="form-control"
                placeholder="Message"
                style={{ height: "400px" }}
              />
              <ErrorMessage name="message" component="div" className="error" />
            </div>

            <div className="col-lg-12">
              <div className="form-check-v3 d-none">
                <Field
                  name="agree"
                  type="checkbox"
                  className="checkBoxNew"
                  id="agreeCheckbox"
                  checked={true}
                />
                <label className="ms-2 p-0 m-0" htmlFor="agreeCheckbox">
                  I agree that Bridge Health may contact me at the email address or phone number above.
                </label>
              </div>
              <ErrorMessage name="agree" component="div" className="error" />
            </div>

            <div className="d-flex justify-content-left align-items-left w-100 ml-3">
              <button type="submit" className="form-btn" disabled={isSubmitting}>
                Submit Now
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ReachToUsFormLanding;
